import { PaginationAndSortingParameters } from 'api';

export function getQueryStringParameters<TFilter extends object>(
  query: PaginationAndSortingParameters & { filter?: TFilter }
) {
  const filter = query.filter ?? {};

  return {
    'pagination.page': query.pagination.page,
    'pagination.pageSize': query.pagination.pageSize,
    'sorting.sortField': query.sorting?.sortField,
    'sorting.sortDir': query.sorting?.sortDir,
    ...(Object.entries(filter).reduce(
      (prev, [key, value]) => ({
        ...prev,
        [`filter.${key}`]: value,
      }),
      {}
    ) as AddPrefixToObject<TFilter, 'filter'>),
  };
}

type AddPrefixToObject<T, P extends string> = {
  [K in keyof T as K extends string ? `${P}.${K}` : never]: T[K];
};
